import axios from "axios";
import React, { useEffect, useState } from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Loading from "../../components/loading/Loading";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

const EventData = () => {
 const { eventName } = useParams();
 const decodedEventName = decodeURIComponent(eventName);

  const [eventData, setEventdata] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const columns = [
    { field: "id", headerName: "", width: 50 },
    { field: "name", headerName: "Name", width: 150 },
    { field: "email", headerName: "Email", width: 250 },
    { field: "contact", headerName: "Contact", width: 150 },
    { field: "nationality", headerName: "Nationality", width: 150 },
    {
      field: "winner",
      headerName: "Winner",
      width: 120,
      renderCell: (params) =>
        params.row?.winner ? (
          <strong
            style={{
              color: "green",
              backgroundColor: "lightgreen",
              padding: "10px",
              borderRadius: "3px",
            }}
          >
            🏆 Winner
          </strong>
        ) : (
          ""
        ),
    },
  ];



  useEffect(() => {
    const getEventData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`/get-single-event`, {
          params: { eventName: decodedEventName },
        });
        const mappedEvents = response.data.map((event, i) => ({
          name: event.name || "",
          email: event.email || "",
          id: i + 1,
          contact: event.contact || "",
          nationality: event.nationality || "",
          winner:
            event.winner === true || event.winner === "true" ? true : false,
        }));
        setEventdata(mappedEvents);
      } catch (error) {
        return;
      } finally {
        setLoading(false);
      }
    };

    getEventData();
  }, []);

  return (
    <div className="main_wrp">
      <div className="main_page_wrp">
        <div className="head_wrp">
          <h3>{decodedEventName}</h3>
        </div>
        <div className="main_body_wrp">
          {loading ? (
            <>
              <Loading />
            </>
          ) : (
            <DataGrid
              rows={eventData}
              columns={columns}
              disableRowSelectionOnClick
              getRowId={(row) => row.id}
              // 1. New v8 way to show the toolbar
              showToolbar
              // 2. Settings for the toolbar (like Quick Filter) still go here
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
              // 3. Recommended way to set Page Size in v8
              initialState={{
                pagination: {
                  paginationModel: { pageSize: 5 },
                },
              }}
              pageSizeOptions={[5, 10, 25]}
              sx={{
                "& .MuiDataGrid-row": {
                  cursor: "pointer",
                },
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default EventData;
